import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=7f907d02&scoped=true"
import script from "./info-card.vue?vue&type=script&lang=js"
export * from "./info-card.vue?vue&type=script&lang=js"
import style0 from "./info-card.vue?vue&type=style&index=0&id=7f907d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f907d02",
  null
  
)

export default component.exports